import React from 'react';
import { BUSINESS_INFO } from '../data/mock';
import { useAuth } from '../context/AuthContext';
import { Phone, LogOut, Shield } from 'lucide-react';

export const Header = ({ onLoginClick }) => {
  const { isAdmin, user, logout } = useAuth();

  return (
    <header className="bg-gradient-to-r from-amber-50 to-orange-50 border-b border-amber-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img 
              src={BUSINESS_INFO.logo} 
              alt={BUSINESS_INFO.name}
              className="h-16 w-16 object-contain"
            />
            <div>
              <h1 className="text-xl md:text-2xl font-bold text-amber-900 tracking-tight">
                {BUSINESS_INFO.name}
              </h1>
              <p className="text-amber-700 text-sm flex items-center gap-1">
                <Phone className="w-3 h-3" />
                {BUSINESS_INFO.whatsapp.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3')}
              </p>
            </div>
          </div>
          
          {isAdmin ? (
            <div className="flex items-center gap-3">
              <span className="hidden sm:flex items-center gap-1 text-sm text-amber-700 bg-amber-100 px-3 py-1.5 rounded-full">
                <Shield className="w-3.5 h-3.5" />
                Admin
              </span>
              <button
                data-testid="logout-btn"
                onClick={logout}
                className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium bg-amber-800 text-white hover:bg-amber-900 transition-all duration-300"
              >
                <LogOut className="w-4 h-4" />
                <span className="hidden sm:inline">Cerrar Sesion</span>
              </button>
            </div>
          ) : (
            <button
              data-testid="admin-login-btn"
              onClick={onLoginClick}
              className="px-4 py-2 rounded-lg text-sm font-medium bg-amber-100 text-amber-800 hover:bg-amber-200 transition-all duration-300"
            >
              Admin
            </button>
          )}
        </div>
      </div>
    </header>
  );
};
